<div [formGroup]="group">
  <mat-form-field [hideRequiredMarker]="hideRequiredMarker" class="controls-alignment">
    <mat-label><span>{{field.labelName}}</span>@if (isRequired) {
      <span>*</span>
    }<span class="font-size-small"> (MM/DD/YYYY hh:mm AM/PM)</span></mat-label>
    <input [id]="field.labelName" matInput [owlDateTime]="dt1" [formControlName]="field.labelCode"
       [required]="isRequired">
    <button matSuffix class="datetimebutton" [owlDateTimeTrigger]="dt1" type="button">
      <mat-icon>event</mat-icon>
    </button>
    <owl-date-time #dt1 [pickerType]="'both'" [hour12Timer]="true"
      [startAt]="group.get(field.labelCode)?.value" pickerMode="popup"></owl-date-time>
    @if (group.get(field.labelCode).hasError('owlDateTimeParse')) {
      <mat-error class="date-timePickerError">Please enter date in MM/DD/YYYY hh:mm A format</mat-error>
    } @else if (group.get(field.labelCode).hasError('required')) {
      <mat-error class="date-timePickerError">Date and time is mandatory</mat-error>
    }
  </mat-form-field>
</div>
